import React from 'react';
import {FormGroup, Label, Input} from 'reactstrap';

interface TorusEditorProps {
    diameter: number;
    thickness: number;
    onDiameterChange: (diameter: number) => void;
    onThicknessChange: (thickness: number) => void;
}

const TorusEditor: React.FC<TorusEditorProps> = ({
    diameter,
    thickness,
    onDiameterChange,
    onThicknessChange
}) => {
    const handleDiameterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        onDiameterChange(isNaN(value) ? 0 : value);
    };

    const handleThicknessChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        onThicknessChange(isNaN(value) ? 0 : value);
    };

    return (
        <>
            <FormGroup>
                <Label>Diameter:</Label>
                <Input
                    type="number"
                    step="0.1"
                    value={diameter}
                    onChange={handleDiameterChange}
                />
            </FormGroup>
            <FormGroup>
                <Label>Thickness:</Label>
                <Input
                    type="number"
                    step="0.1"
                    value={thickness}
                    onChange={handleThicknessChange}
                />
            </FormGroup>
        </>
    );
};

export default TorusEditor;
